

import { closePopup, getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';
import classNames from "classnames";
import Modal from 'components/base/Modal';
import { selectCardList } from "data/user/selectors";
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { CircularProgress } from '../Sections/UsageSections';
import CreditCardDropdown from '../components/CreditCardDropdown';
import css from "../style.scss";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { selectUserId } from "data/user/selectors";
import { increaseUsageAPI , getUsageSectionAPI} from 'data/user/actions';

import CVV99Modal from "../components/cvv99Modal";
import LeaveMessagePopup from './LeaveMessage';

const PurchaseSavesAndExportsPopup = (props) => {

  const userID = useSelector(selectUserId);
 const dispatch = useDispatch();
  const cardList = useSelector(selectCardList);
  const [showCVVModal, setShowCVVModal] = useState(false);

  const [totals, setTotals] = useState({
    savesTotal: null,
    exportTotal: null,
  });

  const [selectedCard, setSelectedCard] = useState(cardList[0] || {});


  // const validationSchema = Yup.object({
  //   savesQty: Yup.number()
  //     .nullable()
  //     .transform((value, originalValue) => originalValue === '' ? null : value)
  //     .min(props?.savesMinQuantity, `Minimum quantity is ${props?.savesMinQuantity}`),
    
  //   exportQty: Yup.number()
  //     .nullable()
  //     .transform((value, originalValue) => originalValue === '' ? null : value)
  //     .min(props?.exportsMinQuantity, `Minimum quantity is ${props?.exportsMinQuantity}`),
  // });

  const validationSchema = Yup.object().shape({
    savesQty: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(props?.savesMinQuantity, `Minimum quantity for Saves is ${props?.savesMinQuantity}`)
      .notRequired(),
  
    exportQty: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === '' ? null : value)
      .min(props?.exportsMinQuantity, `Minimum quantity for Exports is ${props?.exportsMinQuantity}`)
      .notRequired(),
  }).test(
    'at-least-one-valid',
    null,
    function (values) {
      const { savesQty, exportQty } = values;
      const isSavesValid = savesQty != null && savesQty >= props?.savesMinQuantity;
      const isExportsValid = exportQty != null && exportQty >= props?.exportsMinQuantity;
  
      if (!isSavesValid && !isExportsValid) {
        // Attach to one of the fields explicitly (better UX)
        return this.createError({ path: 'savesQty', message: 'You must enter either a valid Saves or Exports quantity.' });
      }
  
      return true;
    }
  );

  const formik = useFormik({
    initialValues: { savesQty: null, exportQty: null},
    validationSchema,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      console.log("Form submitted with values:", values);
      handlePurchaseSavesExports({})
      // Handle form submission logic here
    },
  });


  const handleInputChange = (e, key, costEach, min = 0) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    formik.setFieldValue(key, value);



    const quantity = parseInt(value, 10) || 0;
    const total = quantity * (parseFloat(costEach) || 0);

    // Optional: update calculated totals
    if (key === "savesQty") {
      setTotals((prev) => ({
        ...prev,
        savesTotal: total,
      }));
    } else if (key === "exportQty") {
      setTotals((prev) => ({
        ...prev,
        exportTotal: total,
      }));
    }
  };

  const handleClose = () => {
    props.closePopup();
  };

  const handleCardChange = (selectedOption) => {
    setSelectedCard(selectedOption)
  };


  const handlePurchaseSavesExports = async({ cardCode = "" }) => {
    const {savesQty, exportQty } = formik.values;
    let req = {
        userId: userID,
        saveCatalogProductId: props.saveCatalogProductId,
        exportCatalogProductId: props.exportCatalogProductId,
        paymentMethodId: selectedCard?.paymentMethodId ? selectedCard?.paymentMethodId : cardList[0].paymentMethodId,
        approvedAmount: (totals.savesTotal + totals.exportTotal),
        //totalCost: (totals.savesTotal + totals.exportTotal),
        savesQuantity: parseInt(savesQty),
        exportsQuantity: parseInt(exportQty),
    }

    if (Number(totals.savesTotal + totals.exportTotal) > 99 && !cardCode) {
      setShowCVVModal(true);
      return;
    }

     try {
          if (cardCode) {
            req.cardCode = Number(cardCode);
          }
          const response = await increaseUsageAPI(req);
          if (response.success) {
            dispatch(getUsageSectionAPI(userID))
            setShowCVVModal(false);
            handleClose()
          } else {
            console.error(`PurchaseSavesExports failed:`, response.error);
            setShowCVVModal(false);
            dispatch(LeaveMessagePopup.open({
              title: "Error",
              message: response.error,
              yesLable: "Ok",
              cancelLable: null,
              CancelRedirect: () => null,
              yesRedirect: () => null
            }))
          }
        } catch (error) {
          console.error("Unexpected error:", error);
          setShowCVVModal(false);
          dispatch(LeaveMessagePopup.open({
            title: "Error",
            message: response.error,
            yesLable: "Ok",
            cancelLable: null,
            CancelRedirect: () => null,
            yesRedirect: () => null
          }))
        }

  };

  return (
    <Modal modalClassName={css.pricingModal} className={classNames(css.clsAccPageModals, css.clsBillingModal)} isOpen uniqId="PurchaseSavesAndExportsPopup" width="auto" padding="0px 0px 0px" onClose={handleClose}>

      {/* Purchase Saves & Exports */}
      <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0")}>
        <div className={classNames(css.clsModalContent, "modal-content")}>
          <div className={classNames(css.clsModalContentBody, "modal-body")}>
            <div className={css.clsModalHeader}>
              <h2 className={css.clsModalTitle}>Purchase Saves & Exports</h2>
            </div>

            <form onSubmit={formik.handleSubmit}>
            <div className={classNames(css.clsModalBody)}>
              <div className="clearfix w-100">
                <h4 className={classNames(css.clsModalSubTitle2, css.mb_12, "text-left")}> Current Usage </h4>
                <div className={classNames(css.clsUsageCard, css.clsUsageCardSizing)}>
                  <ul className={classNames(css.clsUsageList, css.unstyled)} style={{ justifyContent: "left" }}>
                    <li
                      className={classNames(
                        'p-0'
                      )} style={{ minWidth: "210px", height: "72px" }}
                    >
                      <div className={css.clsUsageContent} style={{ minWidth: "215px", height: "72px" }}>
                        <CircularProgress
                          percentage={100 - props?.savesUsedPercent}
                          type="saveremaing"
                        />
                        <div className={css.clsUsageContentTxt}>
                          <div className={css.clsInfoPopup}>
                            <h5 className={css.clsUsageContentFont} style={{ width: "max-content" }}>
                              <span>Saves Remaining </span>
                            </h5>
                          </div>
                          <h4 className={css.clsUsageContent2}>{props?.savesRemaining?.toLocaleString()}</h4>
                          <div className={css.clsUsageContent3}>
                            <h6>{props?.savesLimit?.toLocaleString()}</h6>
                            <span className={css.clsBorder}></span>
                            <h6>{Math.round(props?.savesUsedPercent)}%</h6>
                            <h6>Used</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li><div className={css.h_line}></div></li>
                    <li className={'p-0'} style={{ minWidth: "225px", height: "72px" }}>
                      <div className={css.clsUsageContent} style={{ minWidth: "225px", height: "72px" }}>
                        <CircularProgress
                          percentage={100 - props?.exportsUsedPercent}
                          type="exportremaining"
                        />
                        <div className={css.clsUsageContentTxt}>
                          <div className={classNames(css.clsInfoPopup, 'w-100')}>
                            <h5 className={classNames(css.clsUsageContentFont)} style={{ width: "max-content" }}>
                              <span>Exports Remaining</span>
                            </h5>
                          </div>
                          <h4 className={css.clsUsageContent2}>{props?.exportsRemaining?.toLocaleString()}</h4>
                          <div className={css.clsUsageContent3}>
                            <h6>{props?.exportsLimit?.toLocaleString()}</h6>
                            <span className={css.clsBorder}></span>
                            <h6>{Math.round(props?.exportsUsedPercent)}%</h6>
                            <h6>Used</h6>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <hr className='my-5'></hr>
                <div className={classNames("d-flex flex-row")} style={{ width: "490px", height: "78px", "justify-content": "space-between", "margin-bottom": "30px" }}>
                  <div className="" style={{ width: "317px", height: "78px" }}>
                    <div className={classNames(css.pb_12px, "d-flex align-items-end")}>
                      <span className={classNames(css.clsModalSubTitle2, "text-left")} style={{ 'margin-right': '6px' }}>Saves </span>
                      <span className={classNames(css.text_16, css.text_sb, css.text_gray, css.clsBorderRight, "w-100")}>{props?.savesMinQuantity?.toLocaleString()} <span className={classNames(css.mr_3, css.text_gray, css.text_14, css.text_m, 'w-100')}>min. qty.</span> </span>
                      <span className={classNames(css.text_16, css.text_sb, css.text_gray, css.pl_10, css.clsBorderLeft, "w-100")}>${props?.savesCostEach?.toLocaleString()} <span className={classNames(css.mr_3, css.text_gray, css.text_14, css.text_m)}>each</span> </span>
                    </div>
                    <p className={classNames(css.text_14, css.text_m, css.text_gray, "mb-0")}>One-Time Save purchases will expire at the end of your current billing cycle and will not roll over.</p>
                  </div>
                  <div className="" style={{ width: "140px", height: "68px", 'margin-top': '7px' }}>
                    <div className="">
                      <div className="">
                        <div className={classNames(css.clsFormGroup)}>
                          <label className={classNames(css.clsFormLabel)}>Saves Quantity </label>
                          <div className={classNames(css.clsFormGroup)}>
                            <input
                              name="savesQty"
                              type="text"
                              className={classNames(
                                css.clsFormControl,
                              )}
                              placeholder="Enter Quantity"
                              value={formik.values.savesQty}
                              min={props?.savesMinQuantity}
                              onChange={(e) => handleInputChange(e, "savesQty", props?.savesCostEach, props?.savesMinQuantity)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classNames("d-flex flex-row")} style={{ width: "490px", height: "78px", "justify-content": "space-between" }}>
                  <div className="" style={{ width: "317px", height: "78px" }}>
                    <div className={classNames(css.pb_10, "d-flex align-items-end")}>
                      <span className={classNames(css.clsModalSubTitle2, "text-left")} style={{ 'margin-right': '6px' }}>Exports </span>
                      <span className={classNames(css.text_16, css.text_sb, css.text_gray, css.pr_10, css.clsBorderRight)} style={{ width: '55%' }}>{props?.exportsMinQuantity?.toLocaleString()}<span className={classNames(css.mr_3, css.text_gray, css.text_14, css.text_m, 'w-100')}>min. qty.</span> </span>
                      <span className={classNames(css.text_16, css.text_sb, css.text_gray, css.pl_10, css.clsBorderLeft, "w-100")}> ${props?.exportsCostEach?.toLocaleString()} <span className={classNames(css.mr_3, css.text_gray, css.text_14, css.text_m)}>each</span> </span>
                    </div>
                    <p className={classNames(css.text_14, css.text_m, css.text_gray, "mb-0")}>One-Time Export purchases will expire at the end of your current billing cycle and will not roll over.</p>
                  </div>
                  <div className="" style={{ width: "140px", height: "68px", 'margin-top': '7px' }}>
                    <div className="">
                      <div className="">
                        <div className={classNames(css.clsFormGroup)}>
                          <label className={classNames(css.clsFormLabel)}>Exports Quantity </label>
                          <div className={classNames(css.clsFormGroup)}>
                            <input
                              name="exportQty"
                              type="text"
                              className={classNames(
                                css.clsFormControl,
                              )}
                              placeholder="Enter Quantity"
                              value={formik.values.exportQty}
                              min={props?.exportsMinQuantity}
                              onChange={(e) => handleInputChange(e, "exportQty", props?.exportsCostEach, props?.exportsMinQuantity)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className='my-5'></hr>
                <div className={classNames("d-flex align-items-center")} style={{ width: "490px", height: "97px", gap: "16px" }}>
                  <div className={classNames()}>
                    <div className={classNames(css.clsFormGroup)}>
                      <label className={classNames(css.clsFormLabel)}> Payment Method</label>
                      <CreditCardDropdown
                        tag={false}
                        paymentMethodType={'In-App Purchases'}
                        options={cardList}
                        onChange={handleCardChange}
                      />
                    </div>
                  </div>
                  <div className={css.h_line} style={{ 'margin-top': "24px" }}></div>
                  <div className="" style={{ 'margin-top': "24px" }}>
                    <h6 className={classNames(css.text_16, css.text_sb, css.text_dark, "text-uppercase mb-2")}>Total</h6>
                    <h4 className={classNames(css.text_30, css.text_sb, css.text_dark, "")}>${(totals.savesTotal + totals.exportTotal).toFixed(2)}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className={classNames(css.clsModalFooter)}>
              <button className={classNames(css.btn_lg, css.btn_primary, css.text_primary,)} onClick={handleClose}> Cancel</button>
              <button type="submit" className={classNames(css.btn_lg, css.clsBtnOrng)} 
               disabled={!formik.isValid}
              >  Purchase Credits </button>
            </div>
            {showCVVModal && <CVV99Modal
              showCVVModal={showCVVModal} cardEnding={selectedCard?.cardEnding} cvvLength={selectedCard?.cardTypeDetails?.codeLength} handleSubmitCVV={handlePurchaseSavesExports} 
              handleCancel={() => setShowCVVModal(false)} handleClose={() => setShowCVVModal(false)}  />}
          </form>
          </div>
        </div>
      </div>

    </Modal>
  );
};


const registrationId = getPopupRegistration(PurchaseSavesAndExportsPopup);
PurchaseSavesAndExportsPopup.open = (props = {}) => openPopup(registrationId, { ...props, priority: Priority.MEDIUM });
PurchaseSavesAndExportsPopup.close = () => closePopup({ popup: registrationId });

export default PurchaseSavesAndExportsPopup;


